import React from 'react';
import "./index.scss";

import OverflowText from "../Textoverflow";
// import CustomTooltip from "../Tooltip";

const ContentBox = ({label, value}) => {
    return (
        <div className="content-box-container p-3 rounded">
            <h4 className="label">{label}</h4>
            <OverflowText text={value !== null && value !== "" ? value : "-"} className={"value"}/>            
        </div>
    )
}

export default ContentBox;